<template>
    <Alert v-if="alertContent" :loadingMood="false" :alertContent="alertContent" @confirm="handleConfirm" @close="alertContent=''"/>
    <div id="related-articles">
        <div id="main-text-content" class="container-size-fixer">
            <div id="direction">
                <ul>
                    <li>خانه</li>
                    <li><img width="7" height="11" src="../assets/new/New/Icon/LeftBreadcrumb.png" alt="left-icon"></li>
                    <li>جست و جو</li>
                </ul>
            </div>
            <div id="related-articles-title">
               {{requested}}
            </div>
        </div>
        <div class="main-container related-articles-content row rtl-direction container-size-fixer" v-if="relatedPosts">
            <NewsView v-for="postInfo in relatedPosts" :postInfo="postInfo" :key="postInfo"/>
        </div>
        <div class="alert-box" v-else-if="loadingMood ==false">
          ( موردی پیدا نشد )
        </div>
        <div class="category-view" v-if="loadingMood">
            <img style="height: auto;width: 40%" src="../assets/loader/output-onlinegiftools.gif" alt="loader">
        </div>
    </div>
</template>

<script>
    import NewsView from '../components/NewsView'
    import Alert from "../components/Alert"
    import axios from "axios"
    export default {
        data() {
            return {
                alertContent: null,
                loadingMood: false,
                relatedPosts: null,
                requested:this.$route.params.requested,
            }
        },
        name: "SearchResults",
        components: {
            NewsView,
            Alert
        },
        methods: {
            async getSearchResults() {
                try {
                    this.relatedPosts =null;
                    this.loadingMood = true;
                    let response = await axios.get('api/getSearchResults/' + this.requested);
                    this.loadingMood = false;
                    this.relatedPosts = response.data.results.relatedPosts;
                    this.moreDataExistence = response.data.results.moreDataExistence;
                } catch (error) {
                    console.log(error)
                }
            },
        },
        mounted() {
            this.getSearchResults();
        },
        watch: { $route(to, from) { if(to !== from){ this.requested = this.$route.params.requested; this.getSearchResults() } } }
    }
</script>

<style lang="scss" scoped>
    .alert-box{
        margin-top: 50px;
    }
    #footer-btn {
        margin-top: 50px;
        width: 100%;
        font-size: 15px;
        color: rgba(26, 26, 26, 1);
    }

    #related-articles {
        min-height: 450px;
        padding: 50px 0;
        width: 100%;
        height: auto;
        background-color: white;
    }

    .related-articles-content {
        padding: 0px !important;;
    }

    #main-text-content {
        margin: auto;
        padding: 10px 20px;
    }


    #direction > ul {
        padding: 0;
        text-align: right;
        list-style-type: none;
    }

    #direction > ul > li {
        min-width: 30px;
        width: auto;
        text-align: center;
        height: auto;
        display: inline-block;
    }

    #direction > ul > li:nth-child(3) {
        opacity: 0.3;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #1a1a1a;
    }

    .main-container {
        max-width: 1120px;
        width: 100%;
        background-color: white !important;
        margin: auto;
        padding: 50px 15px;
    }

    #related-articles-title {
        width: 100%;
        text-align: right !important;
        font-size: 30px !important;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #1a1a1a;

        span {
            color: #cc171d !important;
        }
    }

    @media (max-width: 1300px) {
        #related-articles-title {
            font-size: 26px !important;
        }
    }
</style>